var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5931 2.20301C20.3631 1.34501 19.6881 0.668007 18.8311 0.437007C17.2651 0.00700739 11.0001 7.5965e-06 11.0001 7.5965e-06C11.0001 7.5965e-06 4.73609 -0.00699261 3.16909 0.404007C2.32909 0.633007 1.63509 1.32501 1.40309 2.18201C0.990086 3.74801 0.986085 6.99601 0.986085 6.99601C0.986085 6.99601 0.982085 10.26 1.39209 11.81C1.62209 12.667 2.29709 13.344 3.15509 13.575C4.73709 14.005 10.9851 14.012 10.9851 14.012C10.9851 14.012 17.2501 14.019 18.8161 13.609C19.6721 13.379 20.3501 12.703 20.5831 11.846C20.9971 10.281 21.0001 7.03401 21.0001 7.03401C21.0001 7.03401 21.0201 3.76901 20.5931 2.20301ZM8.99609 10.005L9.00109 4.00501L14.2081 7.01001L8.99609 10.005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.015b614f.svg";
export { ForwardRef as ReactComponent };